import { fetchPasses } from "@/services/passes.queries";
import { useToastNotify } from "@/stores/toastStore";
import { getValueFromStorage } from "@/utils/secureStore";
import { useIsFocused } from "@react-navigation/native";
import { useQuery } from "@tanstack/react-query";
import { useT } from "@transifex/react";
import { useState } from "react";

export const usePasses = () => {
  const { notify } = useToastNotify();
  const [errorNotified, setErrorNotified] = useState(false);
  const t = useT();
  const isFocused = useIsFocused();

  const {
    data: passes,
    fetchStatus,
    error,
    refetch,
  } = useQuery({
    enabled: isFocused,
    queryKey: ["passes"],
    queryFn: async () => {
      const idToken = await getValueFromStorage("idToken");
      if (!idToken) return;
      return await fetchPasses({ cognitoIDToken: idToken || "" });
    },
    staleTime: 0,
  });

  if (error && !errorNotified) {
    setErrorNotified(true);
    notify({ severity: "error", message: t("An error occurred when fetching passes data") });
    console.error("Error fetching passes data:", error);
  }

  if (!error && errorNotified) {
    setErrorNotified(false);
  }

  return {
    passes,
    fetchStatus,
    refetch,
  };
};
